import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigService } from '../config/config.service';

declare var window: any

@Injectable({
	providedIn: 'root'
})
export class SessionService {

	protected resourceUrl: string = "/rest/security/logout"

	constructor(private http: HttpClient, private configService: ConfigService) { }

	public logout(): Observable<{ ok: boolean, entity: string, messageCode: string, errorMessage: string }> {
		return this.http.post<{ ok: boolean, entity: string, messageCode: string, errorMessage: string }>(`${this.resourceUrl}/execute`, null).pipe(map(result => {
			if (result.ok) {
				window.location = result.entity
			}
			return result
		}))
	}

	public reloadToRoot(): void {
		let url = new URL(window.location)
		let theUrl = url.origin + "/eacat"
		if (theUrl.startsWith("http://")) {
			theUrl = this.configService.config.serverAddress
		}

		window.location = theUrl
	}

}
